// OrdersLayout.js
import React, { useState } from 'react';
import useStore from '../../store/zustandstore';
import OrdersSideNav from './orderssidenav';
import '../../orders/orders.css';

const OrdersLayout = ({ children, tab, setTab, data, onBack, backLabel, hideSidenav = false }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const isSidenav = useStore((state) => state.ordersSidenav);
  // Fixed widths (see .bmos-rail in orders.css): a share of the window left
  // the sidebar too narrow for its content on laptops, clipping the collapse arrow.
  const marginLeftClass = isCollapsed ? 'ml-[76px]' : 'ml-[288px]';

  if (!isSidenav) {
    return children;
  }
  // Inside the chart's slide-out the chart already shows the patient panel.
  if (hideSidenav) {
    return <div className="bmor-page">{children}</div>;
  }

  return (
    <div className="flex">
      <OrdersSideNav isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} tab={tab} setTab={setTab} data={data} onBack={onBack} backLabel={backLabel} />
      {/* bmor-page: plain-CSS padding; Bootstrap would turn p-4 into 24px !important. */}
      <div className={`bmor-page flex-grow min-h-screen ${marginLeftClass}`}>
          {children}
      </div>
    </div>
  );
};

export default OrdersLayout;
